import React, { useState } from 'react';
import { Layout } from '../components/Layout';
import { motion, AnimatePresence } from 'framer-motion';
import { UserIcon, MapPinIcon, CalendarIcon, CameraIcon, UploadIcon, CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
const JURISDICTION_STATES = ['VA', 'MD', 'WV'];
export function QuotePage() {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    zip: '',
    state: '',
    availability: ''
  });
  const handleNext = () => setStep(s => s + 1);
  const isWithinJurisdiction = JURISDICTION_STATES.includes(formData.state.toUpperCase());
  return <Layout data-id="element-456">
      <div className="min-h-[70vh] bg-alabaster flex items-center justify-center py-16 px-6" data-id="element-457">
        <div className="w-full max-w-2xl bg-white border-3 border-charcoal p-8 md:p-10 shadow-[16px_16px_0px_0px_rgba(26,26,26,1)]" data-id="element-458">
          <div className="flex justify-between items-center mb-10" data-id="element-459">
            <h1 className="text-3xl font-bold uppercase tracking-tighter" data-id="element-460">
              Get Your Quote
            </h1>
            <div className="flex gap-2" data-id="element-461">
              {[1, 2, 3].map(i => <div key={i} className={`w-3 h-3 border-2 border-charcoal ${step >= i ? 'bg-espresso' : 'bg-transparent'}`} data-id="element-462" />)}
            </div>
          </div>

          <AnimatePresence mode="wait" data-id="element-463">
            {step === 1 && <motion.div key="step1" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} className="space-y-6" data-id="element-464">
                <h2 className="text-xl font-bold font-serif italic" data-id="element-465">
                  Tell us about yourself
                </h2>
                <div className="space-y-4" data-id="element-466">
                  <input type="text" placeholder="Full Name" className="w-full p-4 border-2 border-charcoal/10 focus:border-espresso outline-none" value={formData.name} onChange={e => setFormData({
                ...formData,
                name: e.target.value
              })} data-id="element-467" />
                  <input type="email" placeholder="Email Address" className="w-full p-4 border-2 border-charcoal/10 focus:border-espresso outline-none" value={formData.email} onChange={e => setFormData({
                ...formData,
                email: e.target.value
              })} data-id="element-468" />
                  <input type="tel" placeholder="Phone Number" className="w-full p-4 border-2 border-charcoal/10 focus:border-espresso outline-none" value={formData.phone} onChange={e => setFormData({
                ...formData,
                phone: e.target.value
              })} data-id="element-469" />
                </div>
                <button onClick={handleNext} className="w-full bg-charcoal text-alabaster py-4 font-bold uppercase tracking-widest flex items-center justify-center gap-2 hover:bg-espresso transition-colors" data-id="element-470">
                  Next Step <ArrowRightIcon className="w-4 h-4" data-id="element-471" />
                </button>
              </motion.div>}

            {step === 2 && <motion.div key="step2" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} exit={{
            opacity: 0,
            x: -20
          }} className="space-y-6" data-id="element-472">
                <h2 className="text-xl font-bold font-serif italic" data-id="element-473">
                  Where is your kitchen located?
                </h2>
                <div className="space-y-4" data-id="element-474">
                  <input type="text" placeholder="Zip Code" className="w-full p-4 border-2 border-charcoal/10 focus:border-espresso outline-none" value={formData.zip} onChange={e => setFormData({
                ...formData,
                zip: e.target.value
              })} data-id="element-475" />
                  <select className="w-full p-4 border-2 border-charcoal/10 focus:border-espresso outline-none bg-white" value={formData.state} onChange={e => setFormData({
                ...formData,
                state: e.target.value
              })} data-id="element-476">
                    <option value="" data-id="element-477">Select State</option>
                    <option value="MD" data-id="element-478">Maryland</option>
                    <option value="VA" data-id="element-479">Virginia</option>
                    <option value="WV" data-id="element-480">West Virginia</option>
                    <option value="DC" data-id="element-481">District of Columbia</option>
                    <option value="PA" data-id="element-482">Pennsylvania</option>
                    <option value="OTHER" data-id="element-483">Other</option>
                  </select>
                </div>
                <button onClick={handleNext} className="w-full bg-charcoal text-alabaster py-4 font-bold uppercase tracking-widest flex items-center justify-center gap-2 hover:bg-espresso transition-colors" data-id="element-484">
                  Check Availability <ArrowRightIcon className="w-4 h-4" data-id="element-485" />
                </button>
              </motion.div>}

            {step === 3 && isWithinJurisdiction && <motion.div key="step3-in" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} className="space-y-6" data-id="element-486">
                <div className="bg-espresso/10 p-6 border-l-4 border-espresso" data-id="element-487">
                  <h2 className="text-xl font-bold text-espresso mb-2" data-id="element-488">
                    Great News!
                  </h2>
                  <p className="text-sm text-charcoal/70" data-id="element-489">
                    A technician is available in your area for a free survey.
                  </p>
                </div>
                <div className="space-y-4" data-id="element-490">
                  <label className="block text-sm font-bold uppercase tracking-widest" data-id="element-491">
                    When are you available for a visit?
                  </label>
                  <textarea placeholder="e.g. Monday afternoons or Tuesday mornings..." className="w-full p-4 border-2 border-charcoal/10 focus:border-espresso outline-none h-32" value={formData.availability} onChange={e => setFormData({
                ...formData,
                availability: e.target.value
              })} data-id="element-492" />
                </div>
                <button className="w-full bg-charcoal text-alabaster py-4 font-bold uppercase tracking-widest hover:bg-espresso transition-colors" data-id="element-493">
                  Submit Request
                </button>
              </motion.div>}

            {step === 3 && !isWithinJurisdiction && <motion.div key="step3-out" initial={{
            opacity: 0,
            x: 20
          }} animate={{
            opacity: 1,
            x: 0
          }} className="space-y-6" data-id="element-494">
                <div className="bg-charcoal/5 p-6 border-l-4 border-charcoal" data-id="element-495">
                  <h2 className="text-xl font-bold mb-2" data-id="element-496">
                    Remote Quote Available
                  </h2>
                  <p className="text-sm text-charcoal/70" data-id="element-497">
                    We can provide a custom quote via your photos.
                  </p>
                </div>
                <div className="border-3 border-dashed border-charcoal/20 p-12 flex flex-col items-center justify-center gap-4 bg-alabaster hover:border-espresso transition-colors cursor-pointer group" data-id="element-498">
                  <UploadIcon className="w-10 h-10 text-charcoal/20 group-hover:text-espresso transition-colors" data-id="element-499" />
                  <p className="text-sm font-bold uppercase tracking-widest text-charcoal/40 group-hover:text-charcoal" data-id="element-500">
                    Upload 3 Kitchen Photos
                  </p>
                </div>
                <button className="w-full bg-espresso text-alabaster py-4 font-bold uppercase tracking-widest hover:bg-charcoal transition-colors" data-id="element-501">
                  Get Remote Quote
                </button>
              </motion.div>}
          </AnimatePresence>
        </div>
      </div>
    </Layout>;
}